import { AxiosInstance } from "axios"
import { ZReport, ZReportDetails } from "./zReportsTypes"
import { DateType } from "../../../../../shared/components/filters/selectDateTypeFilter/SelectDateTypeFilter"

export enum AccountingZReportsQuery {
    Z_REPORTS_LIST = "z-reports-list-for-supplier",
}

type FetchZReportsParams = Readonly<{
    supplierId: number
    merchantId: string
    startDate: string
    endDate: string
    dateType: DateType
}>

export type FetchZReportsResponse = Readonly<{
    reportDetails: ZReportDetails
    zReports: Array<ZReport>
}>

export async function fetchZReports(
    params: FetchZReportsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchZReportsResponse> {
    const { supplierId, ...rest } = params

    const url = `/suppliers/${supplierId}/accounting/zReports`

    const response = await axios.get(url, {
        params: rest,
        signal,
    })

    return response.data
}
